const filterButtons = document.querySelectorAll('.entry-grid-filter-button');
const products = document.querySelectorAll('.type-products');
const descriptions = document.querySelectorAll('.entry-grid-filter-content-single');

if(filterButtons.length > 0 && products.length > 0) {

	hideAll();

	filterButtons.forEach((button) => {
		button.addEventListener('click', (event) => {
			filterButtons.forEach((button) => {
				button.classList.remove('button-active');
			});
			event.target.classList.add('button-active');
			showProducts(event.target.dataset.filter);
		});
	});

	showProducts(filterButtons[0].dataset.filter);
	//filterButtons[0].classList.add('button-active');
}

function hideAll() {
	products.forEach((product) => {
		product.classList.add('products-hidden');
	});
	descriptions.forEach((description) => {
		description.classList.add('description-hidden');
	});
}

function showProducts(filterAttr) {
	hideAll();
	products.forEach((product) => {
		if(product.classList.contains('product-categories-' + filterAttr)) {
			product.classList.remove('products-hidden');
		}
	});
	descriptions.forEach((description) => {
		if(description.classList.contains('entry-grid-filter-content-single--' + filterAttr)) {
			description.classList.remove('description-hidden');
		}
	});
}
